/* YOONSEUL · Plantilla editorial del bálsamo (secciones yb-*).
   Galería, carruseles, comparador, compra, pack y cierre. Se inicia una sola vez aunque varias secciones carguen este archivo. */
(function () {
  if (window.YBBalsamo) { window.YBBalsamo.init(document); return; }

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function once(el, key) { if (el.dataset[key] === '1') return false; el.dataset[key] = '1'; return true; }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var comportamiento = reduceMotion ? 'auto' : 'smooth';

  /* ---------- Galería de la ficha ---------- */
  function initGallery(g) {
    if (!once(g, 'ybInit')) return;
    var track = g.querySelector('[data-yb-gal-track]');
    if (!track) return;
    var slides = $$(track, '[data-yb-gal-slide]');
    var thumbs = $$(g, '[data-yb-gal-thumb]');
    var prev = g.querySelector('[data-yb-gal-prev]');
    var next = g.querySelector('[data-yb-gal-next]');
    function actual() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function ir(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: track.clientWidth * i, behavior: comportamiento }); }
    function pintar() {
      var i = actual();
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      var activo = thumbs[i];
      if (activo && activo.parentNode.scrollWidth > activo.parentNode.clientWidth) {
        activo.parentNode.scrollTo({ left: activo.offsetLeft - 20, behavior: comportamiento });
      }
    }
    /* Fotos 2..n: llegan con data-yb-src (yb-ficha.liquid) para no competir con la principal.
       Todas se cargan al primer gesto sobre la galería. Con la página ya cargada y sin gesto solo se
       adelanta la 2.ª, para que el primer deslizamiento sea inmediato sin gastar datos en el resto. */
    var diferidas = $$(track, 'img[data-yb-defer]');
    function cargarFotos(cuantas) {
      if (!diferidas.length) return;
      var lote = typeof cuantas === 'number' ? diferidas.splice(0, cuantas) : diferidas.splice(0);
      lote.forEach(function (img) {
        if (img.dataset.ybSrcset) img.srcset = img.dataset.ybSrcset;
        if (img.dataset.ybSrc) img.src = img.dataset.ybSrc;
        img.removeAttribute('data-yb-defer');
      });
    }
    function cargarSiguiente() { cargarFotos(1); }
    if (diferidas.length) {
      ['pointerdown', 'touchstart', 'focusin', 'wheel', 'mouseenter'].forEach(function (ev) {
        g.addEventListener(ev, cargarFotos, { once: true, passive: true });
      });
      track.addEventListener('scroll', cargarFotos, { once: true, passive: true });
      var tranquilo = function () {
        if ('requestIdleCallback' in window) requestIdleCallback(cargarSiguiente, { timeout: 2500 });
        else setTimeout(cargarSiguiente, 1200);
      };
      if (document.readyState === 'complete') tranquilo();
      else window.addEventListener('load', tranquilo, { once: true });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { cargarFotos(); ir(i); }); });
    if (prev) prev.addEventListener('click', function () { cargarFotos(); ir(actual() - 1); });
    if (next) next.addEventListener('click', function () { cargarFotos(); ir(actual() + 1); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(pintar); }, { passive: true });
    /* Estado inicial en el siguiente fotograma: leer scrollLeft/clientWidth durante la carga forzaba un reflow. */
    requestAnimationFrame(pintar);
    g.ybIr = function (i) { cargarFotos(); ir(i); };
  }

  /* ---------- Carrusel (opiniones) ---------- */
  function initCarousel(c) {
    if (!once(c, 'ybInit')) return;
    var track = c.querySelector('[data-yb-car-track]');
    if (!track) return;
    var items = $$(track, '[data-yb-car-item]');
    var prev = c.querySelector('[data-yb-car-prev]');
    var next = c.querySelector('[data-yb-car-next]');
    var dotsBox = c.querySelector('[data-yb-car-dots]');
    var nav = c.querySelector('[data-yb-car-nav]');
    if (!items.length) return;
    function paso() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }
    function porVista() { return Math.max(1, Math.round((track.clientWidth + 1) / paso())); }
    function posiciones() { return Math.max(1, items.length - porVista() + 1); }
    function actual() { return Math.min(posiciones() - 1, Math.round(track.scrollLeft / paso())); }
    function ir(i) { track.scrollTo({ left: paso() * i, behavior: comportamiento }); }
    function puntos() {
      if (!dotsBox) return;
      var n = posiciones();
      dotsBox.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'yb-car__dot';
        b.setAttribute('aria-label', 'Ir a la opinión ' + (i + 1));
        (function (k) { b.addEventListener('click', function () { ir(k); }); })(i);
        dotsBox.appendChild(b);
      }
      if (nav) nav.hidden = n <= 1;
    }
    function pintar() {
      var i = actual();
      if (dotsBox) $$(dotsBox, '.yb-car__dot').forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { ir(actual() - 1); });
    if (next) next.addEventListener('click', function () { ir(actual() + 1); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(pintar); }, { passive: true });
    var ancho = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== ancho) { ancho = window.innerWidth; puntos(); pintar(); } });
    puntos(); pintar();
  }

  /* ---------- Comparador antes / después ---------- */
  function initCompare(box) {
    if (!once(box, 'ybInit')) return;
    var range = box.querySelector('[data-yb-cmp-range]');
    var arrastrando = false;
    function poner(p) {
      p = Math.max(0, Math.min(100, p));
      box.style.setProperty('--pos', p + '%');
      if (range) { range.value = Math.round(p); range.setAttribute('aria-valuetext', Math.round(p) + ' %'); }
    }
    function desdeEvento(e) { var r = box.getBoundingClientRect(); poner(((e.clientX - r.left) / r.width) * 100); }
    box.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      try { box.setPointerCapture(e.pointerId); } catch (_) {}
      desdeEvento(e);
    });
    box.addEventListener('pointermove', function (e) { if (arrastrando) desdeEvento(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { box.addEventListener(ev, function () { arrastrando = false; }); });
    if (range) range.addEventListener('input', function () { poner(Number(range.value)); });
    poner(Number(box.getAttribute('data-yb-start') || 50));
  }

  /* ---------- Compra (ficha principal) ---------- */
  function variantes(p) {
    var nodo = p.querySelector('[data-yb-variants]');
    try { return nodo ? JSON.parse(nodo.textContent) : []; } catch (_) { return []; }
  }
  function avisar(p, texto) {
    var err = p.querySelector('[data-yb-error]');
    if (!err) return;
    err.textContent = texto || '';
    err.hidden = !texto;
  }
  function aplicarVariante(p, v) {
    if (!v) return;
    var form = p.querySelector('[data-yb-form]');
    if (form && form.elements.id) form.elements.id.value = v.id;
    $$(p, '[data-yb-price]').forEach(function (el) { el.textContent = v.price; });
    $$(p, '[data-yb-compare]').forEach(function (el) { el.textContent = v.compare || ''; el.hidden = !v.compare; });
    $$(p, '[data-yb-badge]').forEach(function (el) { el.textContent = v.pct ? '−' + v.pct + ' %' : ''; el.hidden = !v.pct; });
    $$(p, '[data-yb-submit]').forEach(function (b) {
      b.disabled = !v.available;
      var t = b.querySelector('[data-yb-submit-text]');
      if (t) t.textContent = v.available ? (b.getAttribute('data-label') || t.textContent) : (b.getAttribute('data-soldout') || 'Agotado');
    });
    $$(p, '[data-yb-cod]').forEach(function (b) { b.disabled = !v.available; });
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') || $$(p, '[data-yb-variant-input]').length > 1) {
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('yb:variant', { detail: v }));
  }
  function enviarAlCarrito(form, boton) {
    var datos = new FormData(form);
    if (window.YSCart && typeof window.YSCart.add === 'function') {
      return Promise.resolve(window.YSCart.add(datos, boton));
    }
    if (boton) boton.disabled = true;
    return fetch(raiz + 'cart/add.js', { method: 'POST', body: datos, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = raiz + 'cart'; });
  }
  function initProduct(p) {
    if (!once(p, 'ybInit')) return;
    var lista = variantes(p);
    var form = p.querySelector('[data-yb-form]');
    $$(p, '[data-yb-variant-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var v = lista.filter(function (x) { return String(x.id) === input.value; })[0];
        aplicarVariante(p, v);
      });
    });
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        avisar(p, '');
        var boton = form.querySelector('[data-yb-submit]');
        enviarAlCarrito(form, boton).catch(function () {
          if (boton) boton.disabled = false;
          avisar(p, 'No se ha podido añadir al carrito. Inténtalo de nuevo.');
        });
      }, true);
    }
    var cod = p.querySelector('[data-yb-cod]');
    if (cod && form) {
      cod.addEventListener('click', function () {
        var txt = cod.querySelector('[data-yb-cod-text]');
        var original = txt ? txt.textContent : '';
        if (txt) txt.textContent = 'Preparando tu pedido…';
        cod.disabled = true;
        avisar(p, '');
        var cab = { 'Content-Type': 'application/json', Accept: 'application/json' };
        fetch(raiz + 'cart/add.js', { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('cart'); })
          .then(function () {
            return fetch(raiz + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: cab, body: JSON.stringify({ attributes: { 'Método de pago': 'Contrarreembolso' } }) });
          })
          .then(function () { window.location.href = raiz + 'checkout'; })
          .catch(function () {
            if (txt) txt.textContent = original;
            cod.disabled = false;
            avisar(p, 'No se ha podido continuar. Inténtalo de nuevo.');
          });
      });
    }
    var sticky = p.querySelector('[data-yb-sticky]');
    var principal = p.querySelector('[data-yb-submit]');
    if (sticky && principal && 'IntersectionObserver' in window) {
      if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
      var boton = sticky.querySelector('[data-yb-sticky-add]');
      if (boton) boton.addEventListener('click', function () { if (form && !principal.disabled) form.requestSubmit ? form.requestSubmit(principal) : principal.click(); });
      new IntersectionObserver(function (entradas) {
        var e = entradas[0];
        var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', visible);
        sticky.inert = !visible;
      }).observe(principal);
    }
  }

  /* ---------- Pack recomendado ---------- */
  function initPack(btn) {
    if (!once(btn, 'ybInit')) return;
    btn.addEventListener('click', function (e) {
      var caja = document.querySelector('[data-yb-buybox]');
      if (!caja) return;
      e.preventDefault();
      var modo = btn.getAttribute('data-mode');
      if (modo === 'variant') {
        var id = btn.getAttribute('data-variant');
        var input = caja.querySelector('[data-yb-variant-input][value="' + id + '"]');
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        else {
          var p = caja.closest('[data-yb-product]');
          var v = variantes(p).filter(function (x) { return String(x.id) === id; })[0];
          aplicarVariante(p, v);
        }
      } else {
        var pos = Number(btn.getAttribute('data-pos') || 0);
        var app = caja.querySelector('[class*="kaching" i], kaching-bundles-block, kaching-bundle');
        if (app && pos > 0) {
          var opciones = $$(app, 'input[type="radio"], [role="radio"]');
          if (!opciones.length) opciones = $$(app, '[class*="bar" i]').filter(function (el) { return !el.parentElement.closest('[class*="bar" i]'); });
          if (opciones[pos - 1]) opciones[pos - 1].click();
        }
      }
      caja.scrollIntoView({ behavior: comportamiento, block: 'center' });
    });
  }

  /* ---------- Cierre de compra ---------- */
  function initClose(c) {
    if (!once(c, 'ybInit')) return;
    var boton = c.querySelector('[data-yb-close-add]');
    document.addEventListener('yb:variant', function (e) {
      var v = e.detail || {};
      $$(c, '[data-yb-close-price]').forEach(function (el) { el.textContent = v.price; });
      $$(c, '[data-yb-close-compare]').forEach(function (el) { el.textContent = v.compare || ''; el.hidden = !v.compare; });
      if (boton) boton.disabled = !v.available;
    });
    if (!boton) return;
    boton.addEventListener('click', function () {
      var form = document.querySelector('[data-yb-buybox] [data-yb-form]');
      var principal = form && form.querySelector('[data-yb-submit]');
      if (form && principal && !principal.disabled) {
        if (form.requestSubmit) form.requestSubmit(principal); else principal.click();
        return;
      }
      var id = boton.getAttribute('data-variant');
      if (!id) return;
      var datos = new FormData();
      datos.append('id', id);
      datos.append('quantity', '1');
      if (window.YSCart && typeof window.YSCart.add === 'function') { window.YSCart.add(datos, boton); return; }
      boton.disabled = true;
      fetch(raiz + 'cart/add.js', { method: 'POST', body: datos, credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = raiz + 'cart'; })
        .catch(function () { boton.disabled = false; });
    });
  }

  function init(root) {
    root = root || document;
    $$(root, '[data-yb-gal]').forEach(initGallery);
    $$(root, '[data-yb-car]').forEach(initCarousel);
    $$(root, '[data-yb-cmp]').forEach(initCompare);
    $$(root, '[data-yb-product]').forEach(initProduct);
    $$(root, '[data-yb-pack-btn]').forEach(initPack);
    $$(root, '[data-yb-close]').forEach(initClose);
  }

  window.YBBalsamo = { init: init };
  document.addEventListener('shopify:section:load', function (e) {
    $$(document.body, ':scope > [data-yb-sticky]').forEach(function (s) { s.remove(); });
    init(e.target);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();